<template>
	<div class="loading-screen">
		
		<div class="bars">
			<div class="progress" :style="{ transform: 'translateX(' + x + '%)' }"></div>
		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'loading-screen',
	data() {
		return {
			x: -101
		}
	},
	computed: {
		...mapGetters([ 'lang' ])
	},
	mounted() {
		setTimeout(() => {
			this.x = 0
		}, 100)
	}
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/variables'

.loading-screen
	fixed 0
	flex center center 
	background dark
	color light
	font-size 3.2rem
	text-align center
	.bars
		display inline-block
		height 8px
		width 192px
		background-color darken(dark, 50%)
		overflow hidden
		.progress
			height 100%
			width 100%
			background light
			transition transform 25s easeOutQuad

</style>
